import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProfileButtons from './ProfileButtons';
import DocumentButtons from './DocumentButtons';
import { unAvailableReason } from '_utils/utils';

const ProfileHeader = ({
  profile,
  resourceId,
  activeTab,
  hash,
  permList,
  authUser,
  userData,
  sendingDDForm,
  requestRehireDoc,
  docRequest,
  requestRehireDocStatus,
  onToResourceList,
  onPrint,
  onMailSendOpen,
  onStatusOpen,
  onRemoveEmployee,
  onDdFormConfirmOpen,
  onDocumentRequest,
  onDownloadAllDocuments,
  onDownloadAllDocumentsAsPDF,
  onDocRequestModalClose,
  breadcrumbType = 'resources', // 'resources', 'yourcrew', or 'settings'
  customButtons = null,
  customTitle = null,
  isArchivedEmployees = false,
}) => {
  const getFullName = () => {
    if (!profile) return '';

    const firstName = profile.first_name ?? '';
    const middleName = profile.middle_name ?? '';
    const lastName = profile.last_name ?? '';

    const fullName = (
      firstName +
      ' ' +
      (middleName ? middleName + ' ' : '') +
      lastName
    ).trim();

    return fullName;
  };

  const getUnavailableStatus = () => {
    if (profile?.active !== 'Unavailable') return '';

    const reason = unAvailableReason(
      Number(profile.unavailable_reason),
      profile.other_reason ?? '',
    );

    return reason ? `Unavailable: ${reason}` : 'Unavailable';
  };

  const unavailableStatus = customTitle ? '' : getUnavailableStatus();

  const renderBreadcrumb = () => {
    if (breadcrumbType === 'yourcrew') {
      return (
        <>
          <span className='green' onClick={onToResourceList}>
            Your Crew
          </span>{' '}
          / Profile
        </>
      );
    }

    if (breadcrumbType === 'settings') {
      return (
        <>
          <span className='green'>Settings</span> / Profile
        </>
      );
    }

    return (
      <>
        <Link onClick={onToResourceList} to={'/resources'} className='green'>
          Resources
        </Link>{' '}
        / <Link to={'/resources/' + resourceId}>Details</Link> / Profile
      </>
    );
  };

  return (
    <div className='breadcrumbs'>
      {renderBreadcrumb()}
      <div className='page_title float'>
        <h1>
          {customTitle || getFullName()}
          {unavailableStatus && (
            <small
              className='profile-unavailable-status'
              style={{ display: 'block', fontSize: '13px', fontWeight: 400 }}
            >
              {unavailableStatus}
            </small>
          )}
        </h1>
        <div className='btn_list'>
          {customButtons ? (
            customButtons
          ) : activeTab === 'documents' ? (
            <DocumentButtons
              user={profile}
              permList={permList}
              requestRehireDoc={requestRehireDoc}
              docRequest={docRequest}
              requestRehireDocStatus={requestRehireDocStatus}
              onDocumentRequest={onDocumentRequest}
              onDownloadAllDocuments={onDownloadAllDocuments}
              onDownloadAllDocumentsAsPDF={onDownloadAllDocumentsAsPDF}
              onDocRequestModalClose={onDocRequestModalClose}
            />
          ) : (
            <ProfileButtons
              hash={hash}
              profile={profile}
              permList={permList}
              authUser={authUser}
              userData={userData}
              sendingDDForm={sendingDDForm}
              onPrint={onPrint}
              onMailSendOpen={onMailSendOpen}
              onStatusOpen={onStatusOpen}
              onRemoveEmployee={onRemoveEmployee}
              onDdFormConfirmOpen={onDdFormConfirmOpen}
              isArchivedEmployees={isArchivedEmployees}
            />
          )}
        </div>
      </div>
    </div>
  );
};

ProfileHeader.propTypes = {
  profile: PropTypes.object,
  resourceId: PropTypes.string,
  activeTab: PropTypes.string.isRequired,
  hash: PropTypes.string,
  permList: PropTypes.array,
  authUser: PropTypes.object,
  userData: PropTypes.object,
  sendingDDForm: PropTypes.bool,
  requestRehireDoc: PropTypes.bool,
  docRequest: PropTypes.string,
  requestRehireDocStatus: PropTypes.bool,
  onToResourceList: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  onMailSendOpen: PropTypes.func.isRequired,
  onStatusOpen: PropTypes.func.isRequired,
  onRemoveEmployee: PropTypes.func,
  onDdFormConfirmOpen: PropTypes.func.isRequired,
  onDocumentRequest: PropTypes.func,
  onDownloadAllDocuments: PropTypes.func,
  onDownloadAllDocumentsAsPDF: PropTypes.func,
  onDocRequestModalClose: PropTypes.func,
  breadcrumbType: PropTypes.oneOf(['resources', 'yourcrew', 'settings']),
  customButtons: PropTypes.node,
  customTitle: PropTypes.string,
  isArchivedEmployees: PropTypes.bool,
};

export default ProfileHeader;
